import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {Loner} from "./Loner";
import {ASBonusPickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {LonerGameMode} from "./server/LonerGameMode";
import {LonerGameData} from "./server/LonerData";
import {LonerSound} from "./sound/LonerSound";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";


export class LonerPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName : "Loner",
            hasActionSpin : true,
            bonusGame : {
                header : ()=>"BONUS TICK TICK BOOM",
                options : [
                    {name : "", id : 1, image : "office.png"},
                    {name : "", id : 2, image : "church.png"},
                    {name : "", id : 3, image : "school.png"}
                ],
                type : ASBonusPickOptions.PICK_MODE,
                pickNeededForModes : [LonerGameMode.FEATURE_TICK_TICK_BOOM],
                pickNeededForBuyFeatures : ["TICK_TICK_BOOM", "LUCKY_DRAW", "LUCKY_DRAW_2"] //Needs to be the actual feature name used by server.
            },
            graphics : {backgroundTextureName : "actionSpinBgImage/Intro_BG"},
            getParsedData : (response:LonerGameData, bet:number, prevResponse:LonerGameData):ASWinData => {
                const parsedData:ASWinData = {
                    totalWin : response.accumulatedRoundWin,
                    totalSpinWinnings : this.getWin(response, bet, prevResponse),
                    wasFeatureBuy : response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin : this.isFreeSpinTriggered(response),
                    isBigWin : this.isBigWin(response),
                    winType : this.isMultiPlierMode(response) ? WINTYPE.MULTIPLIER : WINTYPE.NORMAL,
                    featureName : this.getFeatureName(response),
                    isRoundComplete : this.isRoundComplete(response),
                    isBonusEnd : this.isBonusEnd(response),
                    isWinCapHit : response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if(trigger == ActionSpinSound.WIN) {
            Loner.soundPlayer.playSound(LonerSound.AS_WIN);
        } else if(trigger == ActionSpinSound.BIG_WIN) {
            Loner.soundPlayer.playSound(LonerSound.AS_WIN_BIG);
        }
    }

    private isMultiPlierMode(response:LonerGameData):boolean {
        return response.mode === LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK || response.mode === LonerGameMode.FEATURE_PIN_THE_WIN || response.mode === LonerGameMode.FEATURE_TICK_TICK_BOOM;
    }

    private isBigWin(response:LonerGameData):boolean {
        let win = this.isMultiPlierMode(response) ? this.getWin(response, 0, response) * response.playedBetValue : response.totalSpinWinnings;
        let winRatio:number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        if(response.wasFeatureBuy) {
            const betPrice = Loner.getBuyFeaturePrice()
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }
        return winRatio >= 15;
    }

    private getWin(response:LonerGameData, bet:number, prevData:LonerGameData):number {
        if(response.mode === LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
            return response.featureInfo.shotInfo[0].awardMultiplier
        } else if(response.mode === LonerGameMode.FEATURE_TICK_TICK_BOOM) {
            return response.featureInfo.timesBetWinDraw;
        } else if(response.mode === LonerGameMode.FEATURE_PIN_THE_WIN) {
            if(response.reels[0][0] === "S") {
                return response.featureInfo.CornerValues[0] * response.winMultiplier;
            } else if(response.reels[0][4] === "S") {
                return response.featureInfo.CornerValues[2] * response.winMultiplier;
            } else if(response.reels[4][0] === "S") {
                return response.featureInfo.CornerValues[1] * response.winMultiplier;
            } else if(response.reels[4][4] === "S") {
                return response.featureInfo.CornerValues[3] * response.winMultiplier;
            } else {
                return response.totalSpinWinnings;
            }
        } else {
            return response.totalSpinWinnings;
        }
    }

    private getFeatureName(response:LonerGameData):string {
        if(response.mode === LonerGameMode.NORMAL && response.nextMode === LonerGameMode.FEATURE_TICK_TICK_BOOM) {
            return "Pick Bonus Mode";
        }
        if(response.mode === LonerGameMode.FEATURE_TICK_TICK_BOOM && response.nextMode === LonerGameMode.NORMAL) {
            return "TICK TICK BOOM";
        }
        if(response.mode === LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK || response.nextMode === LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
            return "SHOOT SHOOT DUCK";
        }
        if(response.mode === LonerGameMode.FEATURE_PIN_THE_WIN || response.nextMode === LonerGameMode.FEATURE_PIN_THE_WIN) {
            return "PIN THE WIN";
        }

        return "";
    }

    private isFreeSpinTriggered(response:LonerGameData):boolean {
        return (response.mode === LonerGameMode.NORMAL && response.nextMode === LonerGameMode.FEATURE_TICK_TICK_BOOM) ||
            (response.mode === LonerGameMode.NORMAL && response.nextMode === LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) ||
            (response.mode === LonerGameMode.NORMAL && response.nextMode === LonerGameMode.FEATURE_PIN_THE_WIN);
    }

    private isRoundComplete(response:LonerGameData):boolean {
        return ([LonerGameMode.NORMAL, LonerGameMode.FEATURE_TICK_TICK_BOOM, LonerGameMode.FEATURE_PIN_THE_WIN, LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:LonerGameData):boolean {
        return response.mode === LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK && response.nextMode === LonerGameMode.NORMAL;
    }
}